$(document).ready(function () {
  $("#financial_year").change(function () {
    this.form.submit();
  });
});
